export interface ATBInfoContainer {
  readonly vessel: string
  readonly number: string
  readonly eta: string
  readonly cfs: string
  readonly cfsAddress: string
}

export class EmptyATBInfoContainer implements ATBInfoContainer {
  vessel = ''
  cfs = ''
  cfsAddress = ''
  eta =''
  number =''
}

export interface ATBInfoCargo {
  readonly numberOfPieces: number
  readonly euroPLT: number
  readonly onewayPLT: number
  readonly weight: number
}

export class EmptyATBInfoCargo implements ATBInfoCargo {
  euroPLT = -1
  numberOfPieces = -1
  onewayPLT = -1
  weight = 0
}

export interface ATBInfoDetails {
  readonly number: string
  readonly position: string
  readonly unloadingDate: string | null
}

export class EmptyATBInfoDetails implements ATBInfoDetails {
  number = ''
  position = ''
  unloadingDate = null
}

export interface ATBInfo {
  readonly trackingNumber: number
  readonly exportFileReference: string
  readonly container: ATBInfoContainer
  readonly cargo: ATBInfoCargo
  readonly details: ATBInfoDetails
}

export class EmptyATBInfo implements ATBInfo {
  trackingNumber = -1
  exportFileReference = ''
  container = new EmptyATBInfoContainer()
  cargo = new EmptyATBInfoCargo()
  details = new EmptyATBInfoDetails()
}
